import { FC } from 'react';
import { SvgProps } from '../interfaces/Icon';

const ArrowUpDiagonal: FC<SvgProps> = ({ size, className, color }) => {
  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.25 4.5C7.25 3.94772 7.69772 3.5 8.25 3.5H19.5C20.0523 3.5 20.5 3.94772 20.5 4.5V15.75C20.5 16.3023 20.0523 16.75 19.5 16.75C18.9477 16.75 18.5 16.3023 18.5 15.75V6.91421L5.20711 20.2071C4.81658 20.5976 4.18342 20.5976 3.79289 20.2071C3.40237 19.8166 3.40237 19.1834 3.79289 18.7929L17.0858 5.5H8.25C7.69772 5.5 7.25 5.05228 7.25 4.5Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default ArrowUpDiagonal;
